<template>
  <v-app>
    <!--編輯-->
    <v-dialog v-model="isVisible"
              no-click-animation
              max-width="80%">
      <v-card>
        <v-card-title>
          <h3>{{ title }}</h3>
        </v-card-title>
        <v-card-text>
          <v-layout>
            <v-flex md6 xs6>
              <v-btn color="primary" dark text  @click="add()">新增</v-btn>
            </v-flex>
          </v-layout>
          <v-layout v-for="(item, i) of items" :key="item.projectId">
           <v-flex md6 xs6>
             <v-text-field v-model="item.name" label="專案名稱" outline></v-text-field>
           </v-flex >
            <v-flex md2 xs6>
              <v-text-field v-model="item.sort" label="排序" outline></v-text-field>
            </v-flex>
            <v-flex md2 xs6>
              <v-btn color="red" dark text  @click="remove(i)">刪除</v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <span style="color: red;">{{message}}</span>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red" dark text @click="closeEvent">取消</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark text  :loading="saveLoading" @click="saveSetting()">儲存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex';
import { getUUId } from '@/pages/utils/tool';
export default {
  name: 'CCHProjectDialog',
  props: {
    visible: Boolean,
    category: String,
    title: String,
  },
  data() {
    return {
      item: {
        projectId: '',
        name: '',
        sort: '',
      },
      saveLoading: false,
      isVisible: false,
      message: '',
      items: [],
    }
  },
  watch: {
    visible(value) {
      this.message = '';
      this.isVisible = value;
    },
    isVisible(value) {
      if (!value) {
        this.closeEvent()
      } else {
        this.loadData();
      }
    },
  },
  methods: {
    ...mapActions(['saveCCHProjects', 'loadCCHProjects']),
    async loadData() {
      const res = await this.loadCCHProjects({ category: this.category });
      const result = res.data;
      this.items = result.data;
      console.log(`items = ${JSON.stringify(result)}`);
    },
    async saveSetting() {
      let hasError = false;
      if (this.items.length === 0){
        this.message = '請新增項目';
        return;
      }
      for (let item of this.items){
        if (item.name === '' || item.sort === ''){
          hasError = true;
          break;
        }
      }
      if (hasError){
        this.message = '名稱或排序欄位不可空白';
        return;
      }


      this.saveLoading = true;
      const res = await this.saveCCHProjects({
        category: this.category,
        items: this.items,
      });
      this.saveLoading = false;
      const result = res.data;
      console.log(`result ${JSON.stringify(result)}`);

      this.message = result.message;
      setTimeout(() => {
        this.message = '';
      }, 3000);
    },
    closeEvent() {
      this.isVisible = false;
      this.$emit('closeEvent');
    },
    add(){
      this.message = '';
      const item = {
        projectId: getUUId(),
        name: '',
        sort: this.items.length + 1,
        category: this.category
      }
      this.items.push(item)
    },
    remove(i){
      this.message = '';
      this.items.splice(i, 1);
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CCHProjectDialog.vue